import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class LogoutCooldownLimitConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getLogoutCooldownEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.logoutCooldownLimit,
			"v1/currentcustomerlimits/logincooldownlimit"
		);
	}
}
